import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import BOLStyles from './__styles__/BOL.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';
import { BILL_TO } from '../../constants/constants';

class Charges extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired
  };

  render() {
    const { classes, t, shipment } = this.props;
    const { billToInfo } = shipment;
    const isThirdParty = billToInfo.billTo === BILL_TO.THIRD_PARTY;

    return (
      <Fragment>
        <Grid
          container
          spacing={16}
          className={classnames(classes.bolFont, classes.headerText)}
        >
          <Grid item xs={isThirdParty ? 3 : 4}>
            {t('Freight Terms')}:
            <div className={classes.checkboxColor}>
              <input
                type="checkbox"
                disabled={true}
                checked={billToInfo.billTo === BILL_TO.SHIPPER}
              />
              {t('Prepaid')}
              <input
                type="checkbox"
                disabled={true}
                className={classes.textMargin}
                checked={billToInfo.billTo === BILL_TO.CONSIGNEE}
              />
              {t('Collect')}
              {isThirdParty ? <div /> : ''}
              <input
                type="checkbox"
                disabled={true}
                className={classes.textMargin}
                checked={isThirdParty}
              />
              {t('3rd Party')}
            </div>
          </Grid>

          {isThirdParty && (
            <Grid item xs={4}>
              {t('3rd Party Freight Charges Bill to')}:
              <span className={classes.textColor}>
                <p>{billToInfo.billToCompanyName}</p>
                <p>
                  {billToInfo.billToContactInfo.firstName}{' '}
                  {billToInfo.billToContactInfo.lastName}
                </p>
                <p>{billToInfo.billToContactInfo.phone}</p>
                <p>{billToInfo.billToAddress.address1}</p>
                <p>{billToInfo.billToAddress.address2}</p>
                <p>
                  {billToInfo.billToAddress.city},{' '}
                  {billToInfo.billToAddress.state}{' '}
                  {billToInfo.billToAddress.postalCode}
                </p>
              </span>
            </Grid>
          )}

          <Grid item xs={isThirdParty ? 5 : 8}>
            {t('Special Instructions')}:
            <p className={classes.textColor}>{shipment.bolInstructions}</p>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

const translatedCharges = withNamespaces()(Charges);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedCharges);
